<div style="background: #d4d4d7;">

  @if (!pdfLoading) {
  <div class="pdf-viewer-controls-wrapper">
    <div class="pdf-viewer-controls">
      <div class="pdf-control-group">
        <span class="page-counts">Page {{pdfCurrentPage}} of {{pdfTotalPages}}</span>
      </div>

      <div class="pdf-control-divider"></div>

      <div class="pdf-control-group display-flex-buttons">
        <button class="pdf-icon-btn" (click)="pdfZoomOut()" aria-label="Zoom out">
          <span class="material-symbols-outlined">zoom_out</span>
        </button>
        <div class="pdf-zoom-input-wrapper" style="width: 75px; height: 25px;">
          <input style="width: 100%; height: 100%;" class="pdf-zoom-input" type="text" [(ngModel)]="pdfZoomInputValue"
            [ngModelOptions]="{standalone: true}" (focus)="onPdfZoomInputFocus($event)" (blur)="onPdfZoomInputBlur()"
            (keydown.enter)="onPdfZoomInputBlur(); $event.target.blur()">
        </div>
        <button class="pdf-icon-btn" (click)="pdfZoomIn()" aria-label="Zoom in">
          <span class="material-symbols-outlined">zoom_in</span>
        </button>
      </div>

      <div class="pdf-control-divider"></div>

      <div class="pdf-control-group display-flex-buttons">
        <button class="pdf-icon-btn" (click)="pdfRotateLeft()" aria-label="Rotate counter-clockwise">
          <span class="material-symbols-outlined">rotate_left</span>
        </button>
        <span class="pdf-control-label display-flex-buttons">Rotate</span>
        <button class="pdf-icon-btn" (click)="pdfRotateRight()" aria-label="Rotate clockwise">
          <span class="material-symbols-outlined">rotate_right</span>
        </button>
      </div>

      <div class="pdf-control-divider"></div>

      <div class="pdf-control-group display-flex-buttons">
        <button class="pdf-icon-btn pdf-icon-btn--text" (click)="downloadPdf()" aria-label="Download PDF">
          <span class="material-symbols-outlined">download</span>
          <span class="pdf-control-label">Download PDF</span>
        </button>
      </div>
    </div>
  </div>
  }

  <div class="pdf-viewer-document-wrapper" #pdfViewerWrapper>
    @if (pdfLoading) {
    <div class="px-2 loading-spinner" fxLayout="column" fxLayoutAlign="center center">
      <br />
      <h2 class="mat-text-primary">PDF Document is Loading ...</h2>
      <mat-progress-spinner mode="indeterminate" [diameter]="150" [strokeWidth]="5"></mat-progress-spinner>
      <button mat-stroked-button class="mt-3" (click)="goToStmtReviewsList()">Back to Statement Reviews List</button>
    </div>
    }

    <ngx-extended-pdf-viewer [scrollMode]="0" [pageViewMode]="'multiple'" [acceptKeys]="['N', 'P']"
      enablePinchOnMobile="false" enablePrint="false" [handTool]="false" height="100%" [ignoreKeyboard]=false
      [ignoreKeys]="" language="en-us" minZoom="20" maxZoom="400" [(page)]="pdfCurrentPage" [(rotation)]="pdfRotation"
      [showDownloadButton]="false" [showFindButton]="false" [showHandToolButton]="false" [showOpenFileButton]="false"
      [showPagingButtons]="false" [showPresentationModeButton]="false" [showPrintButton]="false"
      [showPropertiesButton]="false" [showRotateButton]="false" [showSecondaryToolbarButton]="false"
      [showSidebarButton]="false" [showSpreadButton]="false" [showToolbar]="false" [showZoomButtons]="false"
      [sidebarVisible]="false" [(src)]="pdfSrc" textLayer="true" useBrowserLocale="true" [(zoom)]="pdfZoom"
      (pdfLoaded)="onPdfLoaded($event)" (pdfLoadingFailed)="onPdfLoadingFailed($event)"
      (progress)="onPdfProgress($event)" (textLayerRendered)="onPdfTextLayerRendered($event)">
    </ngx-extended-pdf-viewer>
  </div>
</div>